var _polygon, _polygon2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdjustments = function SvgAdjustments(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20.14 16 12.2 16 11.43 18.68 20.95 18.68 20.14 16"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.94 8.66 14.31 8.66 13.7 10.79 18.57 10.79 17.94 8.66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm8.62,26H7.38v-.06a3.58,3.58,0,0,1,.37-1.4A2.5,2.5,0,0,1,10,23.1l2.06-7.16v-.06h0L15,6h2.32l3,9.88h0v.06l2.15,7.17a2.07,2.07,0,0,1,1.9,1.42,4.44,4.44,0,0,1,.32,1.41Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdjustments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "adjustments.0d5389c10799007876a6d1c64b1e2a70.svg";